import {
    Button,
    Container,
    Form,
    FormGroup,
    Input,
    Segment,
    SegmentContent,
    SegmentHeader,
    Textarea,
} from '@/platform/ui';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';
import { Link, useForm, usePage } from '@inertiajs/react';
import { useMemo } from 'react';

const CreateOrUpdateView = () => {
    const { objection_content } = usePage().props;
    const { data, setData, errors, post, patch, processing } = useForm({
        ...(objection_content || {}),
    });

    const handleSubmit = () => {
        if (!objection_content?.id) {
            post('/objection-content');

            return;
        }

        patch(`/objection-content/${objection_content.id}`);
    };

    const title = useMemo(
        () => (objection_content?.id ? 'Wijzig bezwaar' : 'Nieuw bezwaar'),
        [objection_content]
    );

    return (
        <Container>
            <Form onSubmit={handleSubmit}>
                <Segment>
                    <SegmentHeader header={title}>
                        <Button as={Link} href='/objection-content'>
                            <ArrowLeftIcon className='size-5' />
                            Terug
                        </Button>
                    </SegmentHeader>
                    <SegmentContent>
                        <FormGroup>
                            <Input
                                label='Naam'
                                required
                                value={data?.name || ''}
                                onChange={event =>
                                    setData('name', event?.target?.value)
                                }
                                error={errors?.name}
                            />
                            <Textarea
                                label='Inhoud'
                                required
                                rows={8}
                                value={data?.content || ''}
                                onChange={event =>
                                    setData('content', event?.target?.value)
                                }
                                error={errors?.content}
                            />
                        </FormGroup>
                    </SegmentContent>
                </Segment>

                <Segment floating>
                    <SegmentContent right>
                        <Button
                            type='submit'
                            variant='primary'
                            loading={processing}
                        >
                            Opslaan
                        </Button>
                    </SegmentContent>
                </Segment>
            </Form>
        </Container>
    );
};

export default CreateOrUpdateView;
